// AIAssistant.jsx
// Embeds the VA chat interface as a CRM page
// Accessible from the sidebar as "AI Assistant"

import React from 'react';

const BASE_URL = process.env.REACT_APP_BASE_URL || window.location.origin;

const AIAssistant = () => {
  return (
    <div className="fade-in" style={{ minHeight: 'calc(100vh - 120px)', display: 'flex', flexDirection: 'column' }}>
      <div style={{ marginBottom: 12 }}>
        <h1 className="section-title">AI Assistant</h1>
        <p className="section-sub">Ask Claude to search leads, check availability, draft messages, and more — in plain English.</p>
      </div>
      <div style={{
        flex: 1,
        borderRadius: 'var(--radius-lg)',
        overflow: 'hidden',
        border: '1px solid var(--stone-200)',
        boxShadow: 'var(--shadow-md)',
        minHeight: 600,
      }}>
        <iframe
          src={`${BASE_URL}/api/va-chat`}
          style={{
            width: '100%',
            height: '100%',
            minHeight: 600,
            border: 'none',
            display: 'block',
          }}
          title="AI Assistant"
        />
      </div>
    </div>
  );
};

export default AIAssistant;
